import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, Award, Printer } from "lucide-react";

export default function CertificateView() {
  const { id } = useParams();
  const [cert, setCert] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/certificates/${id}`).then((r) => setCert(r.data)).catch(() => setErr(true)); }, [id]);

  if (err) return <div className="flex min-h-screen items-center justify-center bg-background text-muted-foreground">Certificate not found.</div>;
  if (!cert) return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;

  return (
    <div className="min-h-screen bg-background px-4 py-10">
      <div className="mx-auto max-w-3xl">
        <button onClick={() => window.print()} data-testid="print-certificate-btn"
          className="mb-4 ml-auto flex items-center gap-2 rounded-lg border border-border bg-secondary px-4 py-2 text-sm font-medium hover:border-primary/50 print:hidden">
          <Printer className="h-4 w-4" /> Print / Save PDF
        </button>
        <div className="relative overflow-hidden rounded-3xl border-4 border-primary bg-white p-10 text-center shadow-2xl">
          <div className="grain absolute inset-0 opacity-50" />
          <div className="relative">
            <div className="mb-1 flex items-center justify-center">
              <img src="/spora1-logo.webp" alt="SPORA1" className="h-16 w-auto" />
            </div>
            <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
              One Ecosystem <span className="text-primary">•</span> One Technology <span className="text-primary">•</span> Many Champions
            </p>
            <Award className="mx-auto h-16 w-16 text-primary" />
            <p className="mt-4 font-mono text-sm uppercase tracking-[0.3em] text-muted-foreground">Certificate of Participation</p>
            <p className="mt-8 text-sm text-muted-foreground">This certifies that</p>
            <h1 className="mt-2 font-display text-5xl font-extrabold text-foreground">{cert.participant_name}</h1>
            <p className="mt-6 text-base text-muted-foreground">
              participated in <span className="font-semibold text-foreground">{cert.event_title}</span>
              {cert.sport ? <> ({cert.sport})</> : null}
              {cert.institution_name ? <> representing <span className="font-semibold text-foreground">{cert.institution_name}</span></> : null}.
            </p>

            {cert.performance?.length > 0 && (
              <div className="mx-auto mt-8 max-w-md space-y-1 rounded-xl border border-border bg-card/60 p-4">
                <p className="mb-2 font-mono text-xs uppercase text-muted-foreground">Results</p>
                {cert.performance.map((p, i) => (
                  <div key={i} className="flex justify-between text-sm"><span>{p.metric}</span><span className="font-mono text-primary">{p.value}{p.position ? ` · ${p.position}` : ""}</span></div>
                ))}
              </div>
            )}

            <div className="mt-10 flex items-center justify-between border-t border-border pt-4 text-xs text-muted-foreground">
              <span className="font-mono">{cert.serial}</span>
              <span>Issued {(cert.issued_at || "").slice(0, 10)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
